import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "app__recipe-popup-container recipe-popup" }
const _hoisted_2 = { class: "recipe-popup__left" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "recipe-popup__right" }
const _hoisted_5 = { class: "recipe-popup__caption" }
const _hoisted_6 = { class: "recipe-popup__title" }
const _hoisted_7 = { class: "recipe-popup__time-and-group" }
const _hoisted_8 = { class: "recipe-popup__time" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "recipe-popup__time-svg" }, null, -1)
const _hoisted_10 = { class: "recipe-popup__group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "recipe-popup__group-svg" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "recipe-popup__info"
}
const _hoisted_13 = {
  key: 0,
  class: "recipe-popup__ingredients"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "recipe-popup__ingredients-title" }, "Ингредиенты", -1)
const _hoisted_15 = { class: "recipe-popup__ingredients-list" }
const _hoisted_16 = {
  key: 1,
  class: "recipe-popup__сooking"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "recipe-popup__сooking-title" }, "Рецепт приготовления", -1)
const _hoisted_18 = { class: "recipe-popup__сooking-list" }
const _hoisted_19 = {
  key: 1,
  class: "recipe-popup__swiper"
}
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = {
  key: 2,
  class: "recipe-popup__products"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "recipe-popup__products-title" }, "Товары для рецепта", -1)
const _hoisted_23 = { class: "recipe-popup__products-carts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_CatalogItem = _resolveComponent("CatalogItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.item.image,
        alt: _ctx.item.name
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.item.name), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(_toDisplayString(_ctx.item.time), 1)
          ]),
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" × " + _toDisplayString(_ctx.item.persons), 1)
          ])
        ])
      ]),
      (_ctx.detailInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.detailInfo.groceryList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("ul", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailInfo.groceryList, (text, idx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: idx,
                        class: "recipe-popup__ingredients-item"
                      }, _toDisplayString(text), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.detailInfo.stages.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("ul", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailInfo.stages, (text, idx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: idx,
                        class: "recipe-popup__сooking-item"
                      }, _toDisplayString(text), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.detailInfo && false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_swiper, {
              navigation: true,
              spaceBetween: 20,
              modules: _ctx.modules,
              pagination: {
            type: 'custom',
            renderCustom(swiper, current, total) {
              return current + ' | ' + total;
            },
          },
              class: "swiperRecipes"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailInfo.images, (img, idx) => {
                  return (_openBlock(), _createBlock(_component_swiper_slide, {
                    class: "recipe-popup__slide",
                    key: idx
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: img,
                        alt: _ctx.item.name
                      }, null, 8, _hoisted_20)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modules", "pagination"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.detailInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailInfo.products.items, (item, idx) => {
                return (_openBlock(), _createBlock(_component_CatalogItem, {
                  key: idx,
                  item: item
                }, null, 8, ["item"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}